import React from 'react'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { FormHelperText, Stack, TextField } from '@mui/material'
import dayjs from 'dayjs'
import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'

import { useAppSelector } from 'redux/Hook'

interface DateRangeProps {
  id: string
  start: string
  end: string
  onChange: (id: string, dateRange: string[], dispatch: Dispatch) => void
}
const DateRange = (props: DateRangeProps) => {
  const { id, start, end, onChange } = props
  const toolState = useAppSelector(
    (state) => state.toolBuilder.toolBuilder,
  ) as Record<string, any>
  const errorMessage = useAppSelector(
    (state) => state.toolBuilder.validation?.[id],
  )
  const dateRange = toolState[id] ? [...toolState[id]] : []
  const dispatch = useDispatch()
  const { fetching, saving } = useAppSelector((state) => state.toolBuilder)

  const handleDateChange = (date: string, index: number) => {
    dateRange[index] = date
    return onChange(id, dateRange, dispatch)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={1} direction="row">
        <DateTimePicker
          inputFormat="DD/MM/YYYY hh:mm A"
          label={start}
          openTo="day"
          disabled={fetching || saving}
          maxDate={dateRange[1] ? dayjs(dateRange[1]) : undefined}
          onChange={(selected) =>
            handleDateChange(selected ? selected.toISOString() : '', 0)
          }
          value={dateRange[0] ? dayjs(dateRange[0]) : null}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
              error={!!errorMessage}
            />
          )}
        />

        <DateTimePicker
          inputFormat="DD/MM/YYYY hh:mm A"
          label={end}
          openTo="day"
          disabled={fetching || saving}
          minDateTime={dateRange[0] ? dayjs(dateRange[0]) : null}
          onChange={(selected) =>
            handleDateChange(selected ? selected.toISOString() : '', 1)
          }
          value={dateRange[1] ? dayjs(dateRange[1]) : null}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
              error={!!errorMessage}
            />
          )}
        />
      </Stack>
      {errorMessage && (
        <FormHelperText sx={{ pl: 2 }} error>
          {errorMessage}
        </FormHelperText>
      )}
    </LocalizationProvider>
  )
}

export default DateRange
